import React, { useState } from 'react'

import { Dashboard, DashboardBackButton, PageLayout } from '@components'
import { HeadContent, Select, Subsection } from '@fourthwall/components'
import { isProduction } from '@fourthwall/utils'
import { useCollectionsQuery } from '@modules/Dashboard/Collections/queries/useCollectionsQuery'
import { useCurrentShopQuery } from '@modules/Dashboard/hooks/useCurrentShopQuery'
import { routing } from '@utils/routing'

import linktreeSignet from '../../assets/signets/linktree.svg'
import { ConnectBar } from '../../components/ConnectBar/ConnectBar'

export const AppsLinktree = () => {
  const { currentShopQuery } = useCurrentShopQuery()
  const { collectionsQuery } = useCollectionsQuery([{ onlyPublic: true }])
  const [selectedCollection, setSelectedCollection] = useState<string>('all')
  const publicCollections = (collectionsQuery.data?.collections || []).map((collection) => ({
    value: collection.slug,
    label: collection.name,
  }))
  const internalDomain = currentShopQuery.data?.internalDomain
  const suffix = isProduction() ? 'fourthwall.com' : 'staging.fourthwall.com'
  const shopUrl = internalDomain ? `${internalDomain}.${suffix}` : null

  return (
    <>
      <HeadContent title="Linktree" />
      <PageLayout size="tiny">
        <Dashboard.Section
          name="Linktree"
          topContent={<DashboardBackButton label="Apps" to={routing.apps.self} />}
        >
          <Subsection>
            {shopUrl && (
              <ConnectBar
                logoSrc={linktreeSignet}
                info={
                  <Select
                    options={publicCollections}
                    label="Select a collection to display on your Linktree"
                    value={selectedCollection}
                    onValueChange={setSelectedCollection}
                    fullWidth
                  />
                }
                connectButtonLabel="Add"
                onConnect={() => {
                  window.open(
                    `${routing.external.linktree.createLink}&url=${encodeURIComponent(`https://${shopUrl}/collections/${selectedCollection}`)}`,
                    '_blank',
                  )
                }}
              />
            )}
          </Subsection>
        </Dashboard.Section>
      </PageLayout>
    </>
  )
}
